/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

import AuthGuard from '../Utils/RouteGuard/AuthGuard';
import Footer from './Footer';
import Header from './Header';
import Loader from './Loader';
import Sidebar from './Sidebar';
import Taptop from './Taptop';
import MobileBottomNavbar from './MobileBottomNavbar';
import { EmailVerificationBanner } from './EmailVerificationBanner';
import { RootState } from '../store/Store';
import { addSidebarTypes } from '../store/reducers/Layout/ThemeCustomizerReducer';
import { setSideBarToggle } from '../store/reducers/Layout/LayoutReducer';
import { useDispatch } from 'react-redux';

export default function Layout() {
   const { sideBarToggle } = useSelector((state: RootState) => state.layout);
   const { sidebar_types } = useSelector(
      (state: RootState) => state.themeCustomizer
   );

   const dispatch = useDispatch();

   const updateSidebarBasedOnWidth = () => {
      const windowWidth = window.innerWidth;
      if (sidebar_types === 'compact-wrapper') {
         if (windowWidth <= 1200) {
            dispatch(setSideBarToggle(true));
         } else {
            dispatch(setSideBarToggle(false));
         }
      } else if (sidebar_types === 'horizontal-wrapper') {
         if (windowWidth <= 992) {
            dispatch(setSideBarToggle(true));
            dispatch(addSidebarTypes('compact-wrapper'));
         } else {
            dispatch(setSideBarToggle(false));
            dispatch(addSidebarTypes('horizontal-wrapper'));
         }
      }
   };

   useEffect(() => {
      updateSidebarBasedOnWidth();
      window.addEventListener('resize', () => {
         updateSidebarBasedOnWidth();
      });
   }, [sidebar_types]);

   useEffect(() => {
      const handleLock = () => {
         const isMobile = window.innerWidth < 992;

         if (isMobile && !sideBarToggle) {
            document.body.style.overflow = 'hidden';
         } else {
            document.body.style.overflow = '';
         }
      };

      handleLock();
      window.addEventListener('resize', handleLock);

      return () => {
         window.removeEventListener('resize', handleLock);
         document.body.style.overflow = '';
      };
   }, [sideBarToggle]);

   return (
      <AuthGuard>
         <Taptop />
         <Loader />
         <div
            className={`page-wrapper ${sideBarToggle ? 'compact-wrapper sidebar-open' : sidebar_types}`}
            id="pageWrapper"
         >
            <Header />
            <div
               className={`bg-overlay ${!sideBarToggle ? 'show' : ''}`}
               onClick={() => dispatch(setSideBarToggle(true))}
            ></div>
            <div className="page-body-wrapper">
               <EmailVerificationBanner />
               <Sidebar />
               <Outlet />
               <Footer />
            </div>
         </div>
         <MobileBottomNavbar />
      </AuthGuard>
   );
}
